"use client";

import { c as _c } from "react/compiler-runtime";
import { GET_MEDIAS } from "@/graphql/queries/media-query";
import { useSuspenseQuery } from "@apollo/client/react";
import { Carousel, CarouselApi, CarouselContent, CarouselItem } from "../ui/carousel";
import { MediaCard } from "./media-card";
import { useEffect, useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { SliderPagination } from "./slider-pagination";
export const SpoclearnInMediaSlider = () => {
  const $ = _c(20);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      fetchPolicy: "cache-first"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data
  } = useSuspenseQuery(GET_MEDIAS, t0);
  const [api, setApi] = useState();
  const [current, setCurrent] = useState(0);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  const [count, setCount] = useState(0);
  let t1;
  let t2;
  if ($[1] !== api) {
    t1 = () => {
      if (!api) {
        return;
      }
      const updateState = () => {
        setCount(api.scrollSnapList().length);
        setCurrent(api.selectedScrollSnap());
        setCanScrollPrev(api.canScrollPrev());
        setCanScrollNext(api.canScrollNext());
      };
      updateState();
      api.on("select", updateState);
      api.on("reInit", updateState);
      return () => {
        api.off("select", updateState);
        api.off("reInit", updateState);
      };
    };
    t2 = [api];
    $[1] = api;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      align: "start"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== data?.medias) {
    t4 = data?.medias.map(_temp);
    $[5] = data?.medias;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <Carousel setApi={setApi} opts={t3} className="w-full"><CarouselContent>{t4}</CarouselContent></Carousel>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== api || $[10] !== canScrollNext || $[11] !== canScrollPrev || $[12] !== count || $[13] !== current) {
    t6 = count > 1 && <div className="flex items-center justify-center gap-1.5 pt-2"><button onClick={() => api?.scrollPrev()} className="border-border bg-background text-foreground hover:bg-muted hover:text-muted-foreground flex h-8 w-8 items-center justify-center rounded-full border transition-colors disabled:pointer-events-none disabled:opacity-50" disabled={!canScrollPrev} aria-label="Previous slide"><ChevronLeftIcon className="h-4 w-4" /></button><SliderPagination current={current} count={count} onChange={i => api?.scrollTo(i)} /><button onClick={() => api?.scrollNext()} className="border-border bg-background text-foreground hover:bg-muted hover:text-muted-foreground flex h-8 w-8 items-center justify-center rounded-full border transition-colors disabled:pointer-events-none disabled:opacity-50" disabled={!canScrollNext} aria-label="Next slide"><ChevronRightIcon className="h-4 w-4" /></button></div>;
    $[9] = api;
    $[10] = canScrollNext;
    $[11] = canScrollPrev;
    $[12] = count;
    $[13] = current;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <div>{t6}</div>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <div>{t5}{t7}</div>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
function _temp(media, index) {
  return <CarouselItem key={index} className="basis-full sm:basis-1/2 md:basis-1/3"><div className="p-1"><MediaCard mediaUrl={media.media_url} logo={media.media_logo} publishAt={media.publish_at} description={media.description} readingTime={media.reading_time} headline={media.headline} mediaHouseName={media.media_house_name} /></div></CarouselItem>;
}